var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._t("default",null,{"active":_vm.active,"toggle":_vm.toggle,"activate":_vm.onActivate})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }